import querystring from 'query-string';
import { ParrotLinkParams } from '@insurgrid/common';
import { usePathname, useParams, useRouter } from 'next/navigation';
import { useQueryClient } from '@tanstack/react-query';
import { useNavUtils } from '../../components/resources/navigationHooks/useNavUtils';
import { QueryKey } from '../../types';
import { CLIENT_ID_KEY, SHOW_EXTRACTED_DATA_STORAGE_KEY } from '../data';
import { useClientId } from './useClientId';
import { insurgridVisitorFunnelTrackingUuidKey } from './useTrackUserVisitMutation';

export function useClearClient() {
  const { readClientIdFromUrlOrStorage } = useClientId();
  const clientId = readClientIdFromUrlOrStorage();
  const queryClient = useQueryClient();
  const { generatePath } = useNavUtils();
  const pathname = usePathname();
  const params = useParams();
  const { replace } = useRouter();
  const agentSlug = params?.agentSlug;

  const clearClient = async () => {
    if (agentSlug && pathname) {
      const path = generatePath(pathname, {
        agentSlug,
      });
      const queryFreePath = querystring.exclude(path, ['clientId']);
      await replace(queryFreePath);
    }
    localStorage.removeItem(CLIENT_ID_KEY);
    sessionStorage.removeItem(CLIENT_ID_KEY);
    localStorage.removeItem(insurgridVisitorFunnelTrackingUuidKey);
    localStorage.removeItem(
      ParrotLinkParams.ShowAcceleratedUnderwritingQuestions,
    );
    localStorage.removeItem(SHOW_EXTRACTED_DATA_STORAGE_KEY);
    queryClient.removeQueries({ queryKey: [QueryKey.Client, clientId] });
    queryClient.removeQueries({
      queryKey: [clientId, QueryKey.Submissions],
    });
  };

  return { clearClient };
}
